import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const sectionRoutes = [
  "scores",
  "features",
  "guides",
  "news",
  "events",
  "calendar",
  "leagues",
  "rankings",
  "players",
  "data",
  "live",
  "videos",
  "teams",
  "watch",
  "cities",
  "newsletter",
  "sources"
];

export default new Router({
  mode: "hash",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: "/", name: "home" },
    ...sectionRoutes.map((name) => ({ path: `/${name}`, name })),
    { path: "/sports/:id", name: "sport" },
    { path: "/news/:id", name: "news-detail" },
    { path: "/topics/:id", name: "topic-detail" },
    { path: "/guides/:id", name: "guide-detail" },
    { path: "/events/:id", name: "event-detail" },
    { path: "/calendar/:date", name: "calendar-date" },
    { path: "/leagues/:id", name: "league-detail" },
    { path: "/venues/:id", name: "venue-detail" },
    { path: "/matches/:id", name: "match-detail" },
    { path: "/players/:id", name: "player-detail" },
    { path: "/authors/:id", name: "author-detail" },
    { path: "/videos/:id", name: "video-detail" },
    { path: "/teams/:id", name: "team-detail" },
    { path: "/tags/:tag", name: "tag" },
    { path: "/search/:keyword?", name: "search" },
    { path: "*", redirect: "/" }
  ]
});
